


























import Vue from "vue";
import {Component, Prop, Watch} from "vue-property-decorator";
//@ts-ignore
import store from "../../../store";
import {CurrentGame, GameAutomation, PlayerAutomationStatus} from "../../../../types";
import MessageHelper from "../../../helpers/MessageHelper";
import EventApi from "../../../api/EventsApi";
import MafiaIntro from "./MafiaIntro.vue";

@Component({
    components: {MafiaIntro},
})

/**
 * Компонент состояния стола (время суток) для автоматизации мафии
 */
export default class TimesOfDay extends Vue {
    @Prop({required: true}) private readonly color!: string;

    private showIntro: boolean = false;

    mounted(): void
    {
        EventApi.addEventListener(EventApi.START_INTRO, this.startIntro);
    }

    /**
     * Смотрим, закрыли ли Интро. Если другой игрок закрыл интро, то надо скрывать у всех
     * @param newVal
     * @param oldVal
     */
    @Watch('introIsFinished')
    onIntroFinish(newVal: boolean, oldVal: boolean)
    {
        if (newVal) {
            this.showIntro = false;
        }
    }

    /**
     * Является ли игрок гостем
     * @private
     */
    private get isGuest(): boolean
    {
        return store.getters.getPlayerConnectionStatus === 'guest';
    }

    /**
     * Интро закончено
     * @private
     */
    private get introIsFinished(): boolean
    {
        return this.gameState.tasks.state.game_intro_finished;
    }

    private get gameState(): any
    {
        return store.getters.getGameState;
    }

    private get introIsVisible(): boolean
    {
        return this.showIntro && !this.introIsFinished;
    }

    private get playerId(): any
    {
        return store.getters.getPlayerId;
    }

    /** Видимость кнопки "Ночь" */
    private get isNightButtonVisible(): boolean
    {
        if (this.playerIsOutOfGame || !this.gameAutomation) {
            return false;
        }

        return this.gameAutomation.tasksContainer.nextTaskButton.enabled;
    }

    /**
     * Определить ccs-класс победителя: red-мафия, blue-гражданские
     * @private
     */
    private get winnerClass(): string
    {
        if (!this.winnerId) {
            return '';
        }

        return this.winnerId.toString() === '2' ? 'red' : 'blue';
    }

    /**
     * Автоматизация игры
     */
    private get gameAutomation(): GameAutomation|null
    {
        return this.gameState.automation;
    }

    private get currentActivity(): CurrentGame|null
    {
        return store.getters.getCurrentActivity;
    }

    /**
     * ID Победителя в мафии
     * @private
     */
    private get winnerId(): string|null
    {
        if (!this.gameAutomation) {
            return null;
        }
        return this.gameAutomation?.winnerId ? this.gameAutomation?.winnerId.toString() : null;
    }

    /**
     * Текущий раунд
     * @private
     */
    private get roundNumber(): number
    {
        if (!this.gameAutomation) {
            return 1;
        }
        return this.gameAutomation.stage.value;
    }

    /**
     * Название периода день/ночь
     * @private
     */
    private get periodName(): string
    {
        return this.roundNumber % 2 ? 'day' : 'night';
    }

    /**
     * Статус игрока в автоматизации игры
     */
    private get playerStatus(): PlayerAutomationStatus|null
    {
        return store.getters.getPlayerAutomationStatus(this.playerId);
    }

    /**
     * Игрок выбыл из игры
     * @private
     */
    private get playerIsOutOfGame(): boolean
    {
        return this.playerStatus?.value === 2 || this.playerStatus?.value === 3;
    }

    /**
     * Запустить ночь
     * @private
     */
    private startNight(): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        MessageHelper.getContentPackTasksMessage(
            {
                contentPackId: this.gameState.tasks.state.content_pack_id,
                setId: this.gameState.tasks.state.set_id,
            }
        )
    }

    /**
     * Перезапустить игру
     * @private
     */
    private startNewGame(): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        EventApi.triggerEvent(EventApi.SHOW_RESTART_GAME_MODAL);
    }

    /**
     * Запустить интро игры
     * @private
     */
    private startIntro(): void
    {
        this.showIntro = true;
    }

    /**
     * Запустить игру после интро
     * @private
     */
    private startGame(): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        this.showIntro = false;
        MessageHelper.finishIntro({
            'activityId': this.currentActivity ? this.currentActivity.id : ''
        });
        this.$analyticsApi.goal('start_game');
    }
}
